export const statusList = {
  "101": "まだ小さく硬い",
  "102": "先が黄色に",
  "103": "先が緑に",
  "104": "半分以上が緑に",
  "105": "先がピンクに",
  "106": "花びらが見えた",
  "107": "花の軸が伸び切った",
  "190": "既に開花",
  "999": "不明"
}

export const analyzedResultComment = (kaikaYear,kaikaMonth,kaikaDay,mankaiYear,mankaiMonth,mankaiDay,statusCode,isPast,isFuture) => {
  if(kaikaYear&&kaikaMonth&&kaikaDay) {
    if(isFuture) {
      if (statusCode === "101") {
        return 'つぼみはまだまだ小さく硬い状態で、ぐっすりと眠っています。 咲くのは1ヶ月以上先になりそうです。 これからゆっくりと春の準備を始めていく様子を、のんびり見守っていきましょう。'
      } else {
        return 'このつぼみが開花するのは1ヶ月以上先になりそうです。 春の日差しを浴びてゆっくりと準備を始めていく様子を、のんびり見守っていきましょう。'
      }
    } else if(statusCode === "101") {
      return `つぼみは『まだ小さく硬い』状態で、ぎゅっと閉じているみたいです。これから暖かくなるにつれて、ゆっくり眠りから覚めていきます。${kaikaMonth}月${kaikaDay}日頃の開花に向けて、色が少しずつ変わっていく様子を楽しみましょう。桜が満開になるのは${mankaiMonth}月${mankaiDay}日頃の予想です。`
    } else if(statusCode === "102") {
      return `つぼみの先が、ほんのり黄色くなってきました！春の日差しを感じて、少しずつ準備を始めているのかもしれません。${kaikaMonth}月${kaikaDay}日頃に咲くのが待ち遠しいですね。桜が満開になるのは${mankaiMonth}月${mankaiDay}日頃の予想です。`
    } else if(statusCode === "103") {
      return `いまのつぼみは、『先が緑』の状態です。お日様のパワーを浴びて、どんどん元気になっています。${kaikaMonth}月${kaikaDay}日頃の開花に向けて、次はピンク色が見えてくるのが待ち遠しいですね。${mankaiMonth}月${mankaiDay}日頃には、見ごたえのある満開の姿が見られそうです。`
    } else if(statusCode === "104") {
      return `つぼみが半分以上、緑色に包まれてきました。順調に育っていますね！このまま暖かい日が続けば、${kaikaMonth}月${kaikaDay}日頃には花が開きそうです。ピンクの花びらがひょっこり顔を出すまで、あともう少し。${mankaiMonth}月${mankaiDay}日頃には、見ごたえのある満開の姿が見られそうです。`
    } else if(statusCode === "105") {
      return `つぼみの先がピンク色になってきました！これこそ「もうすぐ咲くよ」という桜からのメッセージ。${kaikaMonth}月${kaikaDay}日頃には、きれいなお花に会えそうです🌸桜が満開になるのは${mankaiMonth}月${mankaiDay}日頃の予想です。`
    } else if(statusCode === "106") {
      return `つぼみから花びらがのぞいています。春の暖かさに誘われて、いよいよ咲こうとしているみたいです。日差しと暖かさがあれば順調に生長し、${kaikaMonth}月${kaikaDay}日頃に開花を迎えます。${mankaiMonth}月${mankaiDay}日頃には、見ごたえのある満開の姿が見られそうです。`
    } else if(statusCode === "107") {
      return `花の軸がぐーんと伸びて、準備が整ったようです。${kaikaMonth}月${kaikaDay}日頃には、待ちに待った開花の瞬間を迎えられそうです。満開の予想は${mankaiMonth}月${mankaiDay}日頃。春本番の景色に出会えるまで、あともう少しです。`
    } else if(statusCode === "190") {
      return (isPast) ? 'この桜は、もうきれいに咲き始めているようです。1年のうちで今しか見られない春の景色を楽しんでください。' : `この桜は、もうきれいに咲き始めているようです。春本番の景色を、ゆっくり楽しんでください。桜が満開になるのは${mankaiMonth}月${mankaiDay}日頃の予想です。`
    }
    else {
      return `いまのつぼみの状態および開花・満開予想日を判定することができませんでした。`
    }
  } else {
    return `いまのつぼみの状態および開花・満開予想日を判定することができませんでした。`
  }
}